import { render, staticRenderFns } from "./addOrEditFirmwareVersion.vue?vue&type=template&id=71283554&scoped=true"
import script from "./addOrEditFirmwareVersion.vue?vue&type=script&lang=js"
export * from "./addOrEditFirmwareVersion.vue?vue&type=script&lang=js"
import style0 from "./addOrEditFirmwareVersion.vue?vue&type=style&index=0&id=71283554&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71283554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71283554')) {
      api.createRecord('71283554', component.options)
    } else {
      api.reload('71283554', component.options)
    }
    module.hot.accept("./addOrEditFirmwareVersion.vue?vue&type=template&id=71283554&scoped=true", function () {
      api.rerender('71283554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware/firmwareDetails/addOrEditFirmwareVersion.vue"
export default component.exports